import React, { Component } from "react";
import { getStatus } from "../../js/components/my-sales/helpers";

class Pill extends Component {
	constructor(props) {
		super(props);
	}


	render() {
		const { className, children, selected, isDisabled, status, ...props } = this.props; // props
		const style = [
			"pill-component",
			!!className ? className : "",
			!!selected ? `is-selected ${getStatus(status)}` : "",
			!!isDisabled ? "is-disabled" : ""
		].join(" ");

		return (
			<div className={style} {...props}>
				{children}
			</div>
		);
	}
}

export default Pill;
